<template>
    <div class="p-fluid mb-3">
        <div class="grid">
            <div class="lg:col-5 md:col-12 sm:col-12 align-items-center justify-content-center">
                <h5>Petunjuk</h5>
                <ol>
                    <li>
                        <p class="line-height-3 m-0">Silahkan download template terlebih dahulu <a target="_blank"
                                href="https://docs.google.com/spreadsheets/d/1fJXxzoKLPp54jtoUMybncPNSFPNJCvxS/edit?gid=1592252073#gid=1592252073"><u><i>DISINI</i></u></a>
                        </p>
                    </li>
                    <li>
                        <p class="line-height-3 m-0">Pastikan file upload excel atau csv</p>
                    </li>
                    <li>
                        <p class="line-height-3 m-0">Pastikan ukuran file tidak lebih dari 2MB</p>
                    </li>
                    <li>
                        <p class="line-height-3 m-0">Pastikan mengisi sesuai dengan kolom tersedia dan sesuai ketentuan
                        </p>
                    </li>

                </ol>
                <div class="line-height-3 m-0" style="color:red;">Catatan: ikuti petunjuk langkah demi langkah dengan
                    baik. Sehingga data akan terupload</div>
            </div>

            <div class="lg:col-1">
                <Divider layout="vertical">
                    <!-- <b>OR</b> -->
                </Divider>
            </div>

            <div class="sm:col-12 md:col-12 lg:col-6">
                <BlockUI :blocked="blockPanel">
                    <form>
                        <div class="field mb-4">
                            <label class="block mb-2">Status</label>
                            <Dropdown v-model="status" :options="dataDropdownStatus" optionLabel="name"
                                optionValue="code" placeholder="Pilih Status" :showClear="true" class="w-full" />
                            <small class="p-error" v-if="errors && errors.status">{{ errors.status[0] }}</small>
                        </div>
                        <FileUpload ref="fileUpload" name="file"
                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            chooseLabel="Choose" uploadLabel="Upload" cancelLabel="Cancel" :customUpload="true"
                            @uploader="onUpload" :fileLimit="1" :maxFileSize="2000000">
                            <template #empty>
                                <p>Seret dan taruh file disini untuk mengunggah.</p>
                                <ProgressBar mode="indeterminate" style="height: .5em" v-if="blockPanel" />
                            </template>
                        </FileUpload>
                    </form>
                </BlockUI>
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters } from "vuex";

export default {
    data() {
        return {
            // upload
            blockPanel: false,
            file: null,
            status: null,

            // dataDropdown
            dataDropdownStatus: [
                { name: 'Aktif', code: 'y' },
                { name: 'Nonaktif', code: 'n' },
            ],
        }
    },
    mounted() {
        this.$store.commit('setErrors', {});
    },
    computed: {
        ...mapGetters(['errors']),
    },
    methods: {
        //UPLOAD
        onUpload(event) {

            this.$store.commit("setErrors", {});
            this.blockPanel = true;
            this.file = event.files[0];

            let data = new FormData();
            data.append('file', this.file);
            if (this.status) {
                data.append('status', this.status);
            }

            this.axios({
                method: 'POST',
                url: process.env.VUE_APP_ROOT_API + 'web/master-salesman/import-bulk-status',
                data: data,
                onUploadProgress: function (e) {
                    this.$refs.fileUpload.progress = parseInt(Math.round((e.loaded * 100) / e.total));
                }.bind(this)
            })
                .then(res => {
                    console.log(res);
                    this.$toast.add({ severity: 'success', summary: 'Successful', detail: 'Data Berhasil Disimpan', life: 3000 });
                    this.$store.commit("setErrors", {});
                    this.$refs.fileUpload.uploadedFileCount = 0;
                    this.$refs.fileUpload.progress = null;
                    this.blockPanel = false;

                    this.clearForms();

                    this.$emit('submit');
                })
                .catch((err) => {
                    console.log(err);
                    this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Data Gagal Disimpan', life: 3000, });
                    this.$refs.fileUpload.uploadedFileCount = 0;
                    this.$refs.fileUpload.progress = null;
                    // this.$refs.message.visible = true;
                    this.blockPanel = false;
                });
        },
        clearForms() {
            this.file = null;
            this.status = null;
        },
    }
}
</script>